import React from 'react'

export default ({ color = '#f2ec1b', children }) => (
  <div className="angle-banner-wrap">
    <div className="angle-banner" style={{ background: color }}>
      {children}
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/partials/angle-banner.js